import { ActionTree } from 'vuex';
import { StateInterface } from '../index';
import { MainStateInterface } from './state';

const actions: ActionTree<MainStateInterface, StateInterface> = {
  someAction (/* context */) {
    // your code
  }
};

export default actions;
